import React, { useState } from "react";
import { bool, func, object, string, array } from "prop-types";
import { connect } from "react-redux";
import { ResponsiveImage } from "@quintype/components";

import { calcWidthsWithDpr, removeHtml } from "../../utils/utils";
import { staticTexts } from "../../utils/Translate";
import { useDevice } from "../../utils/react-utils";

import "./carousel-item.m.css";

const CarouselItem = ({ element, clickImage, lang, showCaption, widths = [400, 600, 800], cfDpr }) => {
  const { title = "", "image-s3-key": slug = "", "image-attribution": attribution = "" } = element;
  const [showMore, setShowMore] = useState(true);
  const [moreActive, setMoreActive] = useState(false);
  const { mobile, name } = useDevice();
  const titleWithoutHtml = removeHtml(title);
  const attributionWithoutHtml = removeHtml(attribution);

  const moreText = (() => {
    if (!titleWithoutHtml || mobile === undefined) return false;
    const charCount = { bn: mobile ? 60 : 90, en: mobile ? 50 : 100 };
    if (String(titleWithoutHtml).length < charCount[lang]) return false;
    return String(titleWithoutHtml).slice(0, charCount[lang]) + "...";
  })();

  const dpr = cfDpr[name] || 1;

  return (
    <div styleName="wrapper" className="popup-wrapper">
      <div styleName={`image-container image-wrapper`} className={`qt-image-dynamic card-image-wrapper`}>
        <figure className="qt-figure">
          <picture className="qt-image">
            <ResponsiveImage
              slug={slug}
              alt={title || "image-s3-key"}
              aspectRatio={[1, 1]}
              imgParams={{ auto: ["format", "compress"], fmt: "webp" }}
              styleName="image"
              onClick={clickImage}
              defaultWidth={800}
              widths={calcWidthsWithDpr(widths, dpr)}
            />
          </picture>
        </figure>
      </div>
      {showCaption && (titleWithoutHtml || attributionWithoutHtml) && (
        <figcaption
          className="image-caption"
          styleName={`caption ${!showMore && moreActive ? "more-active" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            moreText && setShowMore(true);
            moreText && setMoreActive(false);
          }}
        >
          <div styleName="caption-container" className="caption-base">
            {showMore && moreText ? (
              <>
                {moreText}
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    moreText && setShowMore(false);
                    moreText && setMoreActive(true);
                  }}
                  styleName="more-text"
                >
                  {staticTexts(lang).loadMore}
                </span>
              </>
            ) : (
              <>
                {titleWithoutHtml}
                {attributionWithoutHtml && (
                  <span styleName={`image-attribute ${titleWithoutHtml ? "bar" : ""}`}>{attributionWithoutHtml}</span>
                )}
              </>
            )}
          </div>
        </figcaption>
      )}
    </div>
  );
};

CarouselItem.propTypes = {
  element: object,
  clickImage: func,
  showCaption: bool,
  lang: string,
  widths: array,
  cfDpr: object,
};

const mapStateToProps = (state) => ({
  lang: state?.qt?.config?.["publisher-attributes"]?.lang || "bn",
  cfDpr: state.qt.config["publisher-attributes"]["cf-dpr"] || {},
});

export default connect(mapStateToProps)(CarouselItem);
